import React from 'react';
import HomePage from './HomePage';

import { getLocale } from '../lib/localeStore';

export default class extends React.Component {
  state = {
    locale: getLocale(),
  };

  componentDidMount() {
    this.setState({ locale: getLocale() });
  }

  render() {
    return <HomePage {...this.props} locale={this.state.locale} />;
  }
}
